import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RouteAssignment } from '../../../../shared/models/route-assignment';
import { DatePipe } from '@angular/common';
import { ConfigurationModel, FeatureFlagEnum } from '../../../../shared/models/configuration.model';
import moment from 'moment';
import { ImageModel } from '../../../../shared/models/image';
import { Observation } from '../../../../shared/models/observation';
import { ShiftsService } from '../../../../data/shifts/shifts.service';
import { ShiftDistance, ShiftWithDriverAndVehicleModel } from '../../../../shared/models/shift.model';
import { ShiftMapDataService } from '../../services/shift-map-data.service';
import { ActionMenuItem } from '../../../../shared/models/action-menu-item.class';
import { HighlightedItemSource } from '../../../../shared/models/highlighted-item-update';
import { HardwareConfiguration, SensorType } from 'src/app/shared/models/vehicle.model';
import { MapStyles } from '../../../../configuration/map-styles';
import { ToastService } from '../../../../shared/services/toast.service';
import { FormattingModule } from '../../../../shared/formatting/formatting.module';
import { ActionMenuItemComponent } from '../../../../shared/components/action-menu-item/action-menu-item.component';

@Component({
  selector: 'app-assignment-map-panel',
  imports: [DatePipe, FormattingModule, ActionMenuItemComponent],
  templateUrl: './assignment-map-panel.component.html',
  styleUrl: './assignment-map-panel.component.scss',
})
export class AssignmentMapPanelComponent implements OnInit, OnChanges {
  @Input() shift: ShiftWithDriverAndVehicleModel;
  @Input() assignment: RouteAssignment;
  @Input() configuration: ConfigurationModel;
  @Input() images: ImageModel[];
  @Input() observations: Observation[];

  distances: ShiftDistance;
  highlightedObservationId: number;
  observationItems: ActionMenuItem[];

  FeatureFlagEnum = FeatureFlagEnum;
  HardwareConfiguration = HardwareConfiguration;
  SensorType = SensorType;

  constructor(
    private shiftService: ShiftsService,
    private shiftMapManager: ShiftMapDataService,
    private datePipe: DatePipe,
    private toast: ToastService
  ) {}

  ngOnInit() {
    this.shiftService
      .getShiftDistanceDriven(this.assignment.shiftId, this.assignment.id)
      .then(response => {
        this.distances = response.data;
      })
      .catch(error => {
        console.error(error);
        this.distances = null;
        this.toast.short('Error getting track lengths.');
      });

    this.shiftMapManager.highlightedObservation$.subscribe(highlightedObservationUpdate => {
      this.highlightedObservationId = highlightedObservationUpdate.itemId;
      if (!!this.observations) {
        this.updateObservationItems();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const observations = changes['observations']?.currentValue as Observation[];
    if (!!observations) {
      this.updateObservationItems();
    }
  }

  getDuration() {
    const end = moment(this.assignment.completed);
    const start = moment(this.assignment.onAssignmentFrom);
    return moment.duration(end.diff(start));
  }

  hasFeatureFlag(featureFlag: string): boolean {
    return this.configuration.featureFlags.find(value => value.isEnabled && value.name === featureFlag) !== undefined;
  }

  private updateObservationItems() {
    this.observationItems = this.observations.map(observation => this.observationToActionMenuItem(observation));
  }

  private observationToActionMenuItem(observation: Observation): ActionMenuItem {
    return new ActionMenuItem(
      observation.id,
      'stars',
      observation.observationType.title,
      this.datePipe.transform(observation.created, 'shortTime'),
      '',
      null,
      !!observation.observationType.group?.mapColor ? observation.observationType.group.mapColor : MapStyles.LIVE_COLOR,
      () => this.highlightedObservationId === observation.id,
      null,
      null,
      () => this.selectObservation(observation),
      null,
      null,
      [],
    );
  }

  private selectObservation(observation: Observation) {
    this.shiftMapManager.sendHighlightedObservationUpdate(observation.id, HighlightedItemSource.PANEL);
  }
}
